module.exports = __webpack_public_path__ + "media/images/creator/story_count_achievement_mailer/ogp_image_50-3901e1057769eab7596f8d52471e539b.png";